// extracted by mini-css-extract-plugin
export default {"ContentContainer":"TextEditor_ContentContainer__9p+-P","Title":"TextEditor_Title__WOwne"};